import * as uriTemplate from 'urijs/src/URITemplate';
import { IAppConfig } from '../store/interfaces/IAppConfig';
import { ApplicationLocale } from './model/application-locale.model';

export function parseBoolean(bString) {
    try {
        return JSON.parse(('' + bString).toLowerCase());
    } catch (e) {
        return false;
    }
}

export function il8nDate(date, language = 'en', country = 'us', weekday = 'long') {
    const options = {
        weekday: weekday,
        month: 'short',
        day: '2-digit',
        year: 'numeric'
    };

    return new Date(date).toLocaleDateString(
        language.toLowerCase() + '-' + country.toUpperCase(),
        options
    )
        .replace(/\./g, '')
        .replace(/\,/g, '');
}

export function il8nDateNoYear(date, language = 'en', country = 'us', weekday = 'long') {
    const options = {
        weekday: weekday,
        month: 'short',
        day: '2-digit'
    };

    return new Date(date).toLocaleDateString(
        language.toLowerCase() + '-' + country.toUpperCase(),
        options
    )
        .replace(/\./g, '')
        .replace(/\,/g, '');
}

export function dateDifference(startDate: string, endDate: string): number {
    const d1 = new Date(startDate);
    const d2 = new Date(endDate);
    return Math.round((d2.getTime() - d1.getTime()) / (24 * 60 * 60 * 1000));
}

export function redirectToURL(reDirectUrl: string) {
    window.location.href = reDirectUrl;
}

export function localizeURL(url: string = '', appConfig: IAppConfig): string {
    const isBrandDomain = !(window.location.hostname.includes('www.ihg.com') || url.includes('www.ihg.com'));

    const brandSegment = !isBrandDomain && appConfig.brand && appConfig.brand.consolidatedDomainPath
        ? appConfig.brand.consolidatedDomainPath.replace(/^\//, '')
        : undefined;

    return uriTemplate(url)
        .expand({
            hotelBrand: brandSegment,
            country: appConfig.country,
            language: appConfig.language
        });
}

export function getReferrer() {
    return document.referrer;
}

export function scrollTo(element, withoutDelay) {
    let elementPosition;
    try {
        elementPosition = document.getElementsByClassName(element)[0].getBoundingClientRect().top;
    } catch (e) {
        elementPosition = 0;
    }
    if (withoutDelay) {
        window.scrollTo(0, elementPosition);
    } else {
        setTimeout(() => { window.scrollTo(0, elementPosition) }, 2000);
    }
}

const regionMappingObject = {
    'OM': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'NR': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'NP': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'NL': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'AN': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'NC': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'VU': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'NZ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'NI': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Central America'
    },
    'NE': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'NG': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'WF': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'NF': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'NO': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Scandinavia'
    },
    'TK': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'PK': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'PA': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Central America'
    },
    'PG': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'PY': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'PE': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'PH': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'PN': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'PL': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'PT': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'GW': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'TP': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'QA': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'RE': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'RO': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'RW': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'KN': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'SH': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'LC': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'PM': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'North America'
    },
    'VC': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'SM': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'ST': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'TJ': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'SA': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'SN': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'SC': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'SL': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'SG': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'SK': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'SI': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'SO': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'ZA': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'UA': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'ZW': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'NA': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'RU': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'ES': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'SD': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'SR': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'SZ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'SE': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Scandinavia'
    },
    'CH': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'SY': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'TZ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'TH': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'TG': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'TO': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'TT': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'AE': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'TN': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'TR': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'TC': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'TV': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'TM': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'UG': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'EG': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'GB': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'BF': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'UY': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'UZ': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'VA': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'VE': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'VN': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'WX': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'GS': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'WS': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'YE': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'YU': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'ZM': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'US': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'North America'
    },
    'AS': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'CC': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'FM': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'GU': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'MP': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'PR': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'MH': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'UM': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'North America'
    },
    'PW': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'VI': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'AW': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'AF': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'AZ': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'AL': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'DZ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'AM': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'AD': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'AO': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'AI': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'AQ': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'North America'
    },
    'AG': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'AR': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'AU': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'AT': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'BS': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'BH': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'BD': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'BB': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'BA': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'BE': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'BM': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'BJ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'BT': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'BO': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'BW': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'BY': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'BR': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'BZ': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Central America'
    },
    'SB': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'VG': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'BN': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'BG': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'MM': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'BI': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'KH': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'CM': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'CA': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'North America'
    },
    'YT': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'CV': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'KY': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'CF': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'LK': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'TD': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'CL': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'CN': {
        'akamaiRegion': 'GC',
        'akamaiSubRegion': 'Greater China'
    },
    'TW': {
        'akamaiRegion': 'GC',
        'akamaiSubRegion': 'Greater China'
    },
    'CO': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'KM': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'CG': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'CD': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'CK': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'CR': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Central America'
    },
    'HR': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'FO': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Scandinavia'
    },
    'CU': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'CY': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'CS': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'CZ': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'DK': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Scandinavia'
    },
    'DJ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'DM': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'DO': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'EC': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'ER': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'SV': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Central America'
    },
    'EE': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'GQ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'ET': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'FK': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'FJ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'FI': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Scandinavia'
    },
    'FR': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'GF': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'PF': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'GA': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'GM': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'GE': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'DE': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'GH': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'GI': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'KI': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'GR': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'GL': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Scandinavia'
    },
    'GD': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'GP': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'GT': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Central America'
    },
    'GN': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'GY': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'South America'
    },
    'HT': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'HM': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Oceania'
    },
    'HN': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Central America'
    },
    'HK': {
        'akamaiRegion': 'GC',
        'akamaiSubRegion': 'Greater China'
    },
    'HU': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'IS': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Scandinavia'
    },
    'IN': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'ID': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'IR': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'IQ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'IE': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'IL': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'PS': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'IT': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'CI': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'JM': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'SJ': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'JP': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'JO': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'KE': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'KG': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'KP': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'KR': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'KW': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'KZ': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'LA': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'LV': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'LT': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'LB': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Middle East'
    },
    'LS': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'LR': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'LY': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'LI': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'LU': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'MO': {
        'akamaiRegion': 'GC',
        'akamaiSubRegion': 'Greater China'
    },
    'MK': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'MG': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'MD': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Eurasia'
    },
    'MW': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'MY': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'MV': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'ML': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'MT': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'MQ': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'Caribbean'
    },
    'MR': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'MU': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'MX': {
        'akamaiRegion': 'AMER',
        'akamaiSubRegion': 'North America'
    },
    'MC': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'MN': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Asia'
    },
    'MS': {
        'akamaiRegion': 'EUR',
        'akamaiSubRegion': 'Europe'
    },
    'MA': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    },
    'MZ': {
        'akamaiRegion': 'AMEA',
        'akamaiSubRegion': 'Africa'
    }
};

export function getRegionfromCountryCode(countryCode) {
    return regionMappingObject[countryCode] || regionMappingObject['US'];
}

export function getAkamaiCookie(cookieService) {
    return {
        countryCode: cookieService.get('akamaiCountryCode') || 'US',
        latitude: cookieService.get('akamaiLatitude') || '0.0',
        longitude: cookieService.get('akamaiLongitude') || '0.0',
        clientIP: cookieService.get('X-IHG-TrueClient_IP') || '0.0.0.0'
    };
};

const SUPPORTED_BPG_LOGOS = ['ar-ae', 'de-de', 'es-us', 'fr-fr', 'in-id', 'it-it', 'ja-jp', 'ko-kr', 'nl-nl', 'pt-pt', 'ru-ru', 'th-th', 'tr-tr', 'zh-cn', 'zh-tw'];

export function getSupportedBPGLogos() {
    return SUPPORTED_BPG_LOGOS;
}

export function getBpgURL(appConfig): string {

    // remote the slash from the domain path (if there)
    let brandSegment = appConfig.brand.consolidatedDomainPath
        ? appConfig.brand.consolidatedDomainPath.replace(/^\//, '')
        : undefined;

    const bpgURL = uriTemplate(appConfig.bpgImage.imageLink)
        .expand({
            country: appConfig.country,
            language: appConfig.language
        });

    return bpgURL;
}

export function resolveLocale(appConfig: IAppConfig): ApplicationLocale {
    const locale: ApplicationLocale = appConfig ? ApplicationLocale.fromString(useDefault(appConfig.language, '').toLowerCase() + '-' + useDefault(appConfig.country, '').toUpperCase()) : ApplicationLocale.en_US;
    return locale ? locale : ApplicationLocale.en_US;
}

export function useDefault(input: any, defaultVal: any) {
    return input ? input : (input === '' || input === false || input === 0) ? input : defaultVal;
}

export function useFirst(input: any, defaultVal: any) {
    return input && Array.isArray(input) && input.length > 0 ? useDefault(input[0], defaultVal) : defaultVal;
}

export function mapToTypeFromString<T>(type: Object, value: string): T {
    return type ? (<any>Object).keys(type).map((key) => type[key]).find((element) => element === value) : undefined;
}

export const mapToDateTimeFromString = (input: string): Date => {
    const timeNumbers = useDefault(useDefault(input, '').match(/\d+/g), []).map(Number);
    if (timeNumbers && timeNumbers.length > 0) {
        return new Date(0, 0, 0, ...timeNumbers);
    }
    return null;
}

export function isChinaDomain(location): boolean {
  if (location.host.includes('.cn')) {
    return true;
  }
  return false;
}

const INTERCONTINENTAL_ALLIANCE_RESORTS_CODE = "icar";
const INTERCONTINENTAL_ANA_CODE = "ican";

export function getAllianceResort() {
  return INTERCONTINENTAL_ALLIANCE_RESORTS_CODE;
}
export function getAnaHotelsBrand() {
  return INTERCONTINENTAL_ANA_CODE;
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/common.ts